import Layout from '@/mlayout/Layout'
import LayoutFixed from '@/mlayout/LayoutFixed'
const mobileRouter = [{
  path: '/',
  component: Layout,
  redirect: '/main',
  name: 'Main',
  children: [{
    path: '/main',
    component: () => import('@/view/mobile/main/index'),
    name: 'Main',
    roles: []
  }]
},
{
  path: '/whythinkgrow',
  component: Layout,
  name: 'WHY THINKGROW',
  redirect: '/whythinkgrow',
  children: [{
    path: '/whythinkgrow',
    component: () => import('@/view/mobile/whythinkgrow/index'),
    name: 'whythinkgrow',
    roles: []
  }, {
    path: '/samsung',
    component: () => import('@/view/mobile/whythinkgrow/samsung'),
    name: 'samsung',
    roles: []
  }]
},
{
  path: '/houseled',
  component: Layout,
  name: 'SINGLE-BAR LEDs',
  redirect: '/houseled',
  children: [{
    path: '/houseled/:state',
    component: () => import('@/view/mobile/houseled/index'),
    name: 'houseled',
    roles: []
  }, {
    path: '/modeli',
    component: () => import('@/view/mobile/houseled/modeli'),
    name: 'Model-I',
    roles: []
  },
  {
    path: '/modeliplus',
    component: () => import('@/view/mobile/houseled/modelipro'),
    name: 'Model-I Pro',
    roles: []
  }
  ]
},
{
  path: '/indoor',
  component: Layout,
  name: 'MULTIPLE-BAR LEDs',
  redirect: '/indoor',
  children: [{
    path: '/indoor/:state',
    component: () => import('@/view/mobile/indoor/index'),
    name: 'indoor',
    roles: []
  }, {
    path: '/modelh',
    component: () => import('@/view/mobile/indoor/modelh'),
    name: 'Model-H',
    roles: []
  },
  {
    path: '/modelhplus',
    component: () => import('@/view/mobile/indoor/modelhplus'),
    name: 'Model-H Plus',
    roles: []
  },
  // {
  //   path: '/newmodelh',
  //   component: () => import('@/view/mobile/indoor/newmodelh'),
  //   name: 'New Model-H',
  //   roles: []
  // },
  {
    path: '/modelw',
    component: () => import('@/view/mobile/indoor/modelw'),
    name: 'Model-W',
    roles: []
  },
  {
    path: '/modelv',
    component: () => import('@/view/mobile/indoor/modelv'),
    name: 'Model-V',
    roles: []
  },
  ]
},
{
  path: '/smartlifter',
  component: Layout,
  name: 'SMART LIFTER',
  redirect: '/smartlifter',
  children: [{
    path: '/smartlifter',
    component: () => import('@/view/mobile/smartlifter/index'),
    name: 'smartlifter',
    roles: []
  },
  {
    path: '/smartlightlifter',
    component: () => import('@/view/mobile/smartlifter/smartlightlifter'),
    name: 'smartlightlifter',
    roles: []
  },
  ]
},
{
  path: '/modelone',
  component: Layout,
  name: 'MODEL ONE',
  redirect: '/modelone',
  children: [
    {
      path: '/modelone',
      component: () => import('@/view/mobile/modelone/index'),
      name: 'modelone',
      roles: []
    },
    {
      path: '/innercanopy',
      component: () => import('@/view/mobile/modelone/innercanopy'),
      name: 'innercanopy',
      roles: []
    }
  ]
},
{
  path: '/side',
  component: Layout,
  name: 'SIDE LED',
  redirect: '/side',
  children: [{
    path: '/side',
    component: () => import('@/view/mobile/side/index'),
    name: 'SIDE LED',
    roles: []
  }, {
    path: '/daisychain',
    component: () => import('@/view/mobile/side/daisychain'),
    name: 'DAISYCHAIN',
    roles: []
  }]
},
{
  path: '/support',
  component: Layout,
  name: 'SUPPORT',
  redirect: '/support',
  children: [{
    path: '/support',
    component: () => import('@/view/mobile/support/index'),
    name: 'support',
    roles: []
  },
  {
    path: '/controllability',
    component: () => import('@/view/mobile/support/controllability'),
    name: 'controllability',
    roles: []
  },
  {
    path: '/rebate',
    component: () => import('@/view/mobile/support/rebate'),
    name: 'rebate',
    roles: []
  },
  {
    path: '/warranty',
    component: () => import('@/view/mobile/support/warranty'),
    name: 'warranty',
    roles: []
  },
  ]
},
{
  path: '/clode',
  component: Layout,
  name: 'CLONE LED',
  redirect: '/clode',
  children: [{
    path: '/clode',
    component: () => import('@/view/mobile/clode/index'),
    name: 'CLONE LED',
    roles: []
  },]
},
{
  path: '/accessory',
  component: Layout,
  name: 'ACCESSORY',
  redirect: '/accessory',
  children: [{
    path: '/accessory',
    component: () => import('@/view/mobile/accessory/index'),
    name: 'ACCESSORY',
    roles: []
  }, {
    path: '/lifter',
    component: () => import('@/view/mobile/accessory/lifter'),
    name: 'Light Lifter',
    roles: []
  },
  {
    path: '/hanger',
    component: () => import('@/view/mobile/accessory/hanger'),
    name: 'Unistrut Hanger',
    roles: []
  },
  {
    path: '/adapter',
    component: () => import('@/view/mobile/accessory/adapter'),
    name: 'Lighting Adapter',
    roles: []
  },
  {
    path: '/power',
    component: () => import('@/view/mobile/accessory/power'),
    name: 'Power Cord & Plug',
    roles: []
  },
  ]
},
{
  path: '/reseller',
  component: Layout,
  name: 'RESELLER',
  redirect: '/reseller',
  children: [{
    path: '/reseller',
    component: () => import('@/view/mobile/reseller/index'),
    name: 'RESELLER',
    roles: []
  },]
},
{
  path: '/map',
  component: LayoutFixed,
  name: 'Map',
  redirect: '/map',
  children: [{
    path: '/map',
    component: () => import('@/view/mobile/map/index'),
    name: 'Map',
    roles: []
  },]
},
{
  path: '/privacypolicy',
  component: Layout,
  name: 'PrivacyPolicy',
  redirect: '/privacypolicy',
  children: [
    {
      path: '/privacypolicy',
      component: () => import('@/view/mobile/footer/privacypolicy'),
      name: 'PrivacyPolicy',
      roles: []
    },
    {
      path: '/termsofuse',
      component: () => import('@/view/mobile/footer/termsofuse'),
      name: 'TermsOfUse',
      roles: []
    },
  ]
}
]
export default mobileRouter



// WEBPACK FOOTER //
// ./src/router/modules/mobileRouter.js